import { Component, inject, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ErrorComponent } from '@atoms/error/error.component';
import { SharedCommonModule } from '../../common.module';

@Component({
  selector: 'edu-missing-feature-page',
  templateUrl: './missing-feature.component.html',
  imports: [ErrorComponent, SharedCommonModule],
})
export class MissingFeaturePageComponent implements OnInit {
  private readonly activatedRoute = inject(ActivatedRoute);
  missingFeature = signal<string>('');

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      // handle query params here
      this.missingFeature.set(params['missingFeature']);
    });
  }
}
